// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5mscg","comment":"styles_comment__2P9M6"};